module.exports = __webpack_public_path__ + "img/insta-4.2b9212ee.jpg";